import { AppReducer } from './app-reducer';
import { InitialState } from '../state';

export const StarfishDeviceReducer: AppReducer<'StarfishDevice'> = (
    state = InitialState.StarfishDevice,
    action
): typeof state => {
    switch (action.type) {
        case 'StarfishGatewayDevice/Registration/Started':
            return {
                ...state,
                starfishgatewayLoading: true,
                starfishgatewaySuccess: false,
            };

        case 'StarfishGatewayDevice/Registration/Succeeded':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: true,
                connectionString: action.payload.connectionString,
                id: action.payload.id,
            };

        case 'StarfishGatewayDevice/Registration/Failed':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: false,
                errorCode: action.payload.errorCode,
                id: '',
            };
        case 'StarfishGatewayDevice/Registration/Unmounted':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: false,
                loading: false,
                success: false,
                errorCode: '',
                id: '',
            };

        case 'StarfishGatewayDevice/Update/Started':
            return {
                ...state,
                starfishgatewayLoading: true,
                starfishgatewaySuccess: false,
            };

        case 'StarfishGatewayDevice/Update/Succeeded':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: true,
            };
        case 'StarfishGatewayDevice/Update/Reset':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: false,
                loading: false,
                success: false,
                errorCode: '',
                id: '',
            };
        case 'StarfishGatewayDevice/Update/Failed':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: false,
                errorCode: action.payload.errorCode,
                id: '',
            };

        case 'StarfishChildDevice/Update/Started':
            return {
                ...state,
                starfishgatewayLoading: true,
                starfishgatewaySuccess: false,
            };

        case 'StarfishChildDevice/Update/Succeeded':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: true,
            };
        case 'StarfishChildDevice/Update/Reset':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: false,
                loading: false,
                success: false,
                errorCode: '',
                id: '',
            };
        case 'StarfishChildDevice/Update/Failed':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: false,
                errorCode: action.payload.errorCode,
                id: '',
            };
        case 'StarfishChildDevice/Registration/Unmounted':
            return {
                ...state,
                starfishgatewayLoading: false,
                starfishgatewaySuccess: false,
                loading: false,
                success: false,
                errorCode: '',
                id: '',
                deleteChildDeviceSuccess: false,
            };
        case 'DeleteStarfishGateway/Delete/Started':
            return {
                ...state,
                deleteGatewaySuccess: false,
                deleteGatewayMessage: '',
            };

        case 'DeleteStarfishGateway/Delete/Succeeded':
            return {
                ...state,
                deleteGatewaySuccess: true,
                deleteGatewayMessage: action.payload.message,
            };

        case 'DeleteStarfishGateway/Delete/Failed':
            return {
                ...state,
                deleteGatewaySuccess: false,
                deleteGatewayMessage: '',
                errorCode: action.payload.errorCode,
            };

        case 'DeleteStarfishChildDevice/Delete/Started':
            return {
                ...state,
                deleteChildDeviceSuccess: false,
                deleteChildDeviceMessage: '',
            };
        case 'DeleteStarfishChildDevice/Delete/Succeeded':
            return {
                ...state,
                deleteChildDeviceSuccess: true,
                deleteChildDeviceMessage: action.payload.message,
            };
        case 'DeleteStarfishChildDevice/Delete/Failed':
            return {
                ...state,
                deleteChildDeviceSuccess: false,
                deleteChildDeviceMessage: '',
                errorCode: action.payload.errorCode,
            };

        default:
            return state;
    }
};
